import request from 'store/utils/request';

export default async () => {
  try {
    return await request.get('/meta/features/');
  } catch (error) {
    throw error;
  }
};
